import { validatePhoneNumber } from '../utils/helpers';
import { getTechnicalData } from '../utils/storefront/format-resource';

const AttentiveSMSSignUp = async () => {
  const inputFormWrapper = document.querySelector('[data-sms-form]');
  const inputWrapper = inputFormWrapper.querySelector('domaine-input[data-input]');
  const formInput = inputFormWrapper.querySelector('input[type="tel"]');
  const checkBoxWrapper = inputFormWrapper.querySelector('domaine-input[data-checkbox]');
  const checkBoxInput = inputFormWrapper.querySelector('input[type=checkbox]');
  inputWrapper.removeAttribute('error');
  checkBoxWrapper.removeAttribute('error', '');

  try {
    const inputValue = formInput.value.replace(/\D/g, '');

    if (checkBoxInput && !checkBoxInput.checked) {
      inputWrapper.errorText = window.TMW.Strings.general.forms.submitError.optInRequired;
      checkBoxWrapper.setAttribute('error', '');
      throw new Error(window.TMW.Strings.general.forms.submitError.optInRequired);
    }

    if (inputValue.trim().length === 0 || validatePhoneNumber(inputValue) === false) {
      inputWrapper.errorText = window.TMW.Strings.general.forms.submitError.phone;
      throw new Error(window.TMW.Strings.general.forms.submitError.phone);
    }

    const SourceId = getTechnicalData('attentiveSMSSource');
    const apiUrl = getTechnicalData('attentiveSMSAPI');
    const apiId = getTechnicalData('yotpoSMSkey');
    const apiPassword = getTechnicalData('yotpoSMSsecret');

    let formattedPhone = inputValue.trim();
    if (formattedPhone.length === 10) {
      formattedPhone = `+1${formattedPhone}`;
    } else if (formattedPhone.length === 11 && formattedPhone.startsWith('1')) {
      formattedPhone = `+${formattedPhone}`;
    } else if (!formattedPhone.startsWith('+')) {
      formattedPhone = `+${formattedPhone}`;
    }

    const payload = {
      phone: formattedPhone,
      signUpSourceId: SourceId,
    };

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Basic ${btoa(`${apiId}:${apiPassword}`)}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error('Failed to submit SMS to Attentive API via Unifi');
    }

    inputFormWrapper.setAttribute('success', '');
    formInput.value = '';

    setTimeout(() => {
      inputFormWrapper.removeAttribute('success');
    }, 5000);
  } catch (error) {
    inputWrapper.setAttribute('error', '');
  }
};

export default AttentiveSMSSignUp;
